import { defineStore } from 'pinia'
import { type formType} from '@/services/pages/h101';

export const useH102FormStore = defineStore('h102Form', {
  state: () => ({
    formData: null as formType | null,
  }),
  actions: {
    setFormData(userInfo: formType|null) {
      this.formData = userInfo
    },
    clearFormData() {
      this.formData = null
    },
    getFormData() {
      return this.formData
    }
  },

  getters: {
    isAuthenticated: (state) => state.formData !== null
  }
})
